<template>
  <section
    v-if="isParalax"
    :class="['c-full-screen-image', fullScreenClass, absoluteClass]"
  >
    <v-parallax
      :src="backgroundImage"
      :height="paralaxComputedHeight"
      :class="['c-full-screen-image', fullScreenClass]"
    ></v-parallax>
  </section>
  <section
    v-else
    class="c-full-screen-image"
    :class="[backgroundImageSizeClass, fullScreenClass, absoluteClass]"
    :style="backgroundImageStyle"
  ></section>
</template>

<script>
export default {
  name: "FullScreenImage",
  props: {
    backgroundImage: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "contain",
    },
    isParalax: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    paralaxHeight: {
      type: String,
      default: "600",
    },
    absolute: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundImageStyle() {
      return `background-image: url(${this.backgroundImage})`;
    },
    backgroundImageSizeClass() {
      return `c-full-screen-image_size-${this.size}`;
    },
    absoluteClass() {
      return this.absolute ? "c-full-screen-image_is--absolute" : "";
    },
    fullScreenClass() {
      return this.isFullScreen ? "c-full-screen-image_is--fullscreen" : "";
    },
    paralaxComputedHeight() {
      return this.isFullScreen ? window.screen.height : this.paralaxHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-full-screen-image {
  width: 100%;

  background-repeat: no-repeat;
  background-position: center center;
  &.c-full-screen-image_size-cover {
    background-size: cover;
  }
  &.c-full-screen-image_size-contain {
    background-size: contain;
  }
  &.c-full-screen-image_is--fullscreen {
    height: 100%;
  }
  &.c-full-screen-image_is--absolute {
    position: absolute;
    top: 0;
  }
}
</style>
